import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_4 = {
  key: 1,
  class: "flex gap-1"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "flex gap-1"
}

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Voucher, SharedData } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { Button } from '@/components/ui/button';
    import Delete from '@/components/Delete.vue';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import DownloadVouchers from './DownloadVouchers.vue';
    import DownloadStatements from './DownloadStatements.vue';
    import EditVoucher from './EditVoucher.vue';
    import ApproveVoucher from './ApproveVoucher.vue';

    interface Props {
        voucher: Voucher;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherTableActions',
  props: {
    voucher: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.voucher }, {
    default: _withCtx(() => [
      (!_ctx.voucher.uploaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(hasPermission)(_unref(Permission).VOUCHERS_UPDATE) || _unref(hasPermission)(_unref(Permission).VOUCHERS_OWN_UPDATE))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.voucher.has_voucher || _ctx.voucher.is_valid_no_file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(EditVoucher, {
                          voucher: _ctx.voucher,
                          "button-text": "forms.edit",
                          title: "forms.edit"
                        }, null, 8, ["voucher"]),
                        (_unref(hasPermission)(_unref(Permission).VOUCHERS_UPDATE))
                          ? (_openBlock(), _createBlock(ApproveVoucher, {
                              key: 0,
                              voucher: _ctx.voucher
                            }, null, 8, ["voucher"]))
                          : (_openBlock(), _createBlock(DownloadVouchers, {
                              key: 1,
                              voucher: _ctx.voucher
                            }, null, 8, ["voucher"]))
                      ]))
                    : (_openBlock(), _createBlock(EditVoucher, {
                        key: 1,
                        voucher: _ctx.voucher,
                        "button-text": "vouchers.missing_txt",
                        title: "vouchers.missing_txt"
                      }, null, 8, ["voucher"]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(hasPermission)(_unref(Permission).VOUCHERS_VIEW) || _unref(hasPermission)(_unref(Permission).VOUCHERS_OWN_VIEW))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.voucher.has_voucher)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(DownloadVouchers, { voucher: _ctx.voucher }, null, 8, ["voucher"]),
                        (_unref(hasPermission)(_unref(Permission).VOUCHERS_ADMIN_DELETE))
                          ? (_openBlock(), _createBlock(Delete, {
                              key: 0,
                              route: _ctx.route('v2.voucher.admin.attachment.delete', _ctx.voucher.id),
                              "query-key": [_unref(QueryKey).VOUCHERS, selectedCompanyId.value],
                              "button-text": _ctx.$t('vouchers.delete'),
                              header: "vouchers.select.title",
                              description: "vouchers.select.delete_voucher_confirm",
                              "continue-button-text": _ctx.$t('vouchers.delete')
                            }, null, 8, ["route", "query-key", "button-text", "continue-button-text"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.voucher.has_statement)
                      ? (_openBlock(), _createBlock(DownloadStatements, {
                          key: 1,
                          statement: _ctx.voucher.statement
                        }, null, 8, ["statement"]))
                      : (_ctx.voucher.is_valid_no_file)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 2,
                            variant: "delete",
                            size: "xs",
                            disabled: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('button-text.uploaded-without-voucher')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})